import { useCallback, useEffect } from 'react';
import { CandidateStatus, useUpdateCandidateStatus } from '~/domain/PermanentJobs';
import { IToggleControls } from '~/hooks/useToggle';
import {
  HireCandidateConfirmationPopup,
  HireCandidateSuccessPopup,
} from '../../HireCandidatePopups';

interface IProps {
  controls: IToggleControls;
  candidateId: string;
  professionalName: string;
}

export const HirePopupConfirmation = ({ controls, candidateId, professionalName }: IProps) => {
  const { isError, isPending, isSuccess, mutate, reset } = useUpdateCandidateStatus();

  const handleConfirmHireCandidate = () =>
    mutate({ candidateIds: [candidateId], status: CandidateStatus.Hired });

  const handleClosePopup = useCallback(() => {
    reset();
    controls.setOff();
  }, [controls, reset]);

  useEffect(() => {
    if (isError) {
      handleClosePopup();
    }
  }, [handleClosePopup, isError]);

  return (
    <>
      {!isSuccess ? (
        <HireCandidateConfirmationPopup
          isLoading={isPending}
          professionalName={professionalName}
          onClose={handleClosePopup}
          onConfirm={handleConfirmHireCandidate}
        />
      ) : (
        <HireCandidateSuccessPopup onClose={handleClosePopup} />
      )}
    </>
  );
};
